module.exports = __webpack_public_path__ + "static/media/cq_editor_intestazione2.927b0436.svg";